/**
 * Whether the person asked for less motion. Read once, as a component mounts,
 * so an entrance is skipped rather than played (spec 155 FR-014). Anything
 * that keeps moving uses `motion-safe:` classes instead, which follow the
 * setting live.
 */
export function prefersReducedMotion(): boolean {
  try {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch {
    return false;
  }
}
